<template>
  <div style="display: flex">
    <div class="phone" @click="visible = true" :style="{backgroundImage:'url(' + api.temp.FILE_PATH + url.bgUrl + ')'}">
      <img :src="api.temp.FILE_PATH + url.coverUrl" alt="" class="img1">
      <img :src="api.temp.FILE_PATH + url.gjUrl" alt="" class="img2">
    </div>
    <div class="form">
      <Step1 :rowId="actId" :url="url" :templateId="templateId" v-if="index === 0" @cancel="cancel"
             @nextStep="nextStep"></Step1>
      <Step2 :rowId="actId" :templateId="templateId" v-if="index === 1" @lastStep="lastStep"
             @nextStep="nextStep"></Step2>
      <Step3 :rowId="actId" :templateId="templateId" v-if="index === 2" @lastStep="lastStep"
             @nextStep="nextStep"></Step3>
      <Step4 :rowId="actId" :templateId="templateId" v-if="index === 3" @lastStep="lastStep" @saved="saved"></Step4>
    </div>
    <a-modal v-model="visible" title="编辑图片" :width="800" :footer="null">
      <div>首页元素：</div>
      <div class="item">
        <div> 背景图:</div>
        <div>
          <a-upload
              :action="api.temp.UPLOAD_PATH"
              :headers="headers"
              :accept="'.jpg,.gif,.png'"
              :multiple="false"
              @change="handleChange($event,'bgUrl')"
              :showUploadList="false"
              class="avatar-uploader upload"
          >
            <div class="ant-upload-text" v-if="!url.bgUrl">
              <a-icon type="plus"/>
              <div class="ant-upload-text">
                上传图片
              </div>
            </div>
            <img :src="api.temp.FILE_PATH + url.bgUrl" alt="" v-else>
          </a-upload>
        </div>
        <div>图片像素建议为750px*1500px 格式为jpg/png/gif</div>
      </div>
      <div class="item">
        <div> 封面图:</div>
        <div>
          <a-upload
              :action="api.temp.UPLOAD_PATH"
              :headers="headers"
              :accept="'.jpg,.gif,.png'"
              :multiple="false"
              @change="handleChange($event,'coverUrl')"
              :showUploadList="false"
              class="avatar-uploader upload"
          >
            <div class="ant-upload-text" v-if="!url.coverUrl">
              <a-icon type="plus"/>
              <div class="ant-upload-text">
                上传图片
              </div>
            </div>
            <img :src="api.temp.FILE_PATH + url.coverUrl" alt="" v-else>
          </a-upload>
        </div>
        <div>图片像素建议为700px*260px 格式为jpg/png/gif</div>
      </div>
      <div class="item">
        <div> 刮奖区背景:</div>
        <div>
          <a-upload
              :action="api.temp.UPLOAD_PATH"
              :headers="headers"
              :accept="'.jpg,.gif,.png'"
              :multiple="false"
              @change="handleChange($event,'gjUrl')"
              :showUploadList="false"
              class="avatar-uploader upload"
          >
            <div class="ant-upload-text" v-if="!url.gjUrl">
              <a-icon type="plus"/>
              <div class="ant-upload-text">
                上传图片
              </div>
            </div>
            <img :src="api.temp.FILE_PATH + url.gjUrl" alt="" v-else>
          </a-upload>
        </div>
        <div>图片像素建议为130px*190px 格式为jpg/png/gif</div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import api from "@/services/api";
import {dataApi} from "@/services/market/active";
import Step1 from '@/pages/web/market/activeManage/detail/step1'
import Step2 from '@/pages/web/market/activeManage/detail/step2'
import Step3 from '@/pages/web/market/activeManage/detail/step3'
import Step4 from '@/pages/web/market/activeManage/detail/step4'

/**
 * 表单组件
 */
export default {
  components: {
    Step1, Step2, Step3, Step4
  },
  props: ['rowId'],
  data() {
    return {
      api,
      headers: {
        token: localStorage.getItem('token') || ''
      },
      index: 0,
      actId: this.rowId,
      visible: false,
      templateId: 0,
      url: {
        bgUrl: '',
        coverUrl: '',
        gjUrl: ''
      }
    }
  },
  mounted() {
    this.getBaseData()
  },
  methods: {
    getBaseData() {
      dataApi.getTemplateInfoByType(10011).then(res => {
        this.templateId = res.data.templateId
        this.url = JSON.parse(res.data.templateDetail)
      });
      if (this.rowId) {
        this.getDetail()
      }
    },
    getDetail() {
      dataApi.getFormDetail(this.rowId).then(res => {
        this.url = JSON.parse(res.data.elementList[0].elementDetail)
      })
    },
    cancel() {
      this.$emit('cancelled')
    },
    saved() {
      this.$emit('saved')
    },
    nextStep(id) {
      this.actId = id
      this.index++
      document.getElementsByClassName('manage-detail1')[0].getElementsByClassName('ant-modal-body')[0].scrollTop = 0;
    },
    lastStep() {
      document.getElementsByClassName('manage-detail1')[0].getElementsByClassName('ant-modal-body')[0].scrollTop = 0;
      this.index--
    },
    handleChange({file}, row) {
      if (file.status === 'done') {
        let data = file.response.data;
        this.$set(this.url, row, data.url)
        this.submit()
      }
    },
    submit() {
      const params = {
        elementList: [{
          elementDetail: JSON.stringify(this.url),
          backgroundImg: this.url.bgUrl,
          frontImg: this.url.coverUrl
        }],
        actId: this.rowId || 0
      }
      dataApi.saveFormDetail(params)
    }
  }
};
</script>
<style lang="less" scoped>
.phone {
  width: 375px;
  height: 740px;
  border: 1px solid #000;
  margin-right: 24px;
  background-size: 100% 100%;
  position: relative;

  img {
    display: block;
    position: absolute;
  }

  .img1 {
    width: 350px;
    max-height: 200px;
    top: 65px;
    left: 13px;
  }

  .img2 {
    top: 300px;
    width: 350px;
    height: 160px;
    left: 13px;
  }
}

.form {
  flex: 1;
  overflow: hidden;
}

.item {
  display: flex;
  margin: 12px 0;
  line-height: 100px;
}

.upload {
  display: block;
  width: 120px;
  height: 120px;
  border: 1px solid #000;
  margin: 8px;
  text-align: center;

  img {
    display: block;
    max-width: 120px;
    max-height: 120px;
  }
}
</style>